export default function isEnumValue<E extends Record<string, string | number>>(
  enumObj: E,
  value: unknown
): value is E[keyof E] {
  return Object.values(enumObj).some(enumValue => enumValue === value)
}
